export default __webpack_public_path__ + "static/42-a3d924118ebb56535c80fc7d14399170.png";